import { Component, Input } from '@angular/core';

@Component({
  selector: 'svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
  host: { class: 'svg-icon' },
})
export class SvgIconComponent {
  @Input() name: string;
}
